import {
  compile
} from 'handlebars';
import dig from "object-dig";
import React from 'react';
import {
  Arr,
  join
} from '../../../lib/Array.lib';
import fetchCandidateResume from '../../../lib/Candidate/fetchCandidateResume.async';
import Core from "../../../lib/Core";
import Definition, {
  DEFINITION_CATEGORY__ATS_TYPE,
  EMPLOYER_SUBMISSION_METHOD__ATS,
  ID__ATS_TYPE__ASHBY,
  ID__ATS_TYPE__ASHBY_API,
  ID__ATS_TYPE__GH_HARVEST,
  ID__ATS_TYPE__GH_INGESTION,
  ID__ATS_TYPE__LEVER_API
} from "../../../lib/Definition";
import {
  tools,
  YES
} from "../../../lib/GenericTools.lib";
import useState from '../../../lib/hooks/useState.hook';
import {
  Obj
} from '../../../lib/Object.lib';
import fetchAtsContext from '../../../lib/services/ATS/fetchAtsContext.async';
import getAtsContextProperty from '../../../lib/services/ATS/getAtsContextProperty.fun';
import {
  COLLECTION__SOVREN_DATA,
  readLoopbackRecord
} from '../../../lib/services/BE/loopback.api';
import Button from '../../Layout/Wrappers/Button';
import {
  ErrorMessage,
  WarningChipMessage
} from '../../Layout/Wrappers/Message';
import Once from '../../Layout/Wrappers/Once';
import {
  CANDIDATE_UI
} from '../CandidateUI.dic';
import copyATS from './copyATS.fun';

/* METHODS ==================================== */

/**
 *
 * @param {*} props
 * @returns
 */
function AtsSubmitButton(props) {

  const [sendingATS, setSendingATS] = React.useState(false);
  const [isSubmitToAtsFailed, setSubmitToAtsFailed] = React.useState(false);
  const [sovrenRecord, setSovrenRecord] = React.useState();
  const [entity, updateEntity] = useState();

  const {
    atsTypeId,
    employerName,
    submissionMethods,
    manualSubmissionUrl,
    onClick: onClickCallback = async () => { },
    disabled = false,
    candidate,
  } = props;

  const is10x10Employer = !!employerName.match(
    /10\s*(?:x|by)\s*10/i
  );

  const isAtsSubmitDisabled = (
    sendingATS || (
      Core.isOnDev() && !is10x10Employer
    )
  );

  const isAtsManuallyAvailable = (
    submissionMethods.includes(EMPLOYER_SUBMISSION_METHOD__ATS) &&
    (
      ![
        ID__ATS_TYPE__GH_HARVEST,
        ID__ATS_TYPE__GH_INGESTION,
        ID__ATS_TYPE__LEVER_API
      ].includes(atsTypeId) ||
      isSubmitToAtsFailed
    )
  );

  const isAtsGhHarvestSelected = (
    atsTypeId === ID__ATS_TYPE__GH_HARVEST
  );

  const isAtsGhIngestionSelected = (
    atsTypeId === ID__ATS_TYPE__GH_INGESTION
  );

  const VALUE__ATS__API_KEY = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'apiKey'
  });

  const VALUE__ATS__USER__ID = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'userId'
  });

  const YES__ATS__AVAILABLE = (
    Core.isAdmin() && (
      [
        ID__ATS_TYPE__GH_HARVEST,
        ID__ATS_TYPE__GH_INGESTION,
        ID__ATS_TYPE__LEVER_API
      ].includes(atsTypeId) ||
      (
        (ID__ATS_TYPE__ASHBY_API === atsTypeId) &&
        YES(VALUE__ATS__API_KEY) &&
        YES(VALUE__ATS__USER__ID)
      )
    )
  );

  const YES__ATS_TYPE__ASHBY = [
    ID__ATS_TYPE__ASHBY_API,
    ID__ATS_TYPE__ASHBY
  ].includes(atsTypeId);

  const isSubmitToGhHarvestAvailable = (
    Core.isAdminOrCoordinator() &&
    !isAtsManuallyAvailable &&
    isAtsGhHarvestSelected
  );

  const isSubmitToGhIngestionAvailable = (
    Core.isAdminOrCoordinator() &&
    !isAtsManuallyAvailable &&
    isAtsGhIngestionSelected
  );

  const apiName = (
    isSubmitToGhHarvestAvailable
      ? 'harvest'
      : isSubmitToGhIngestionAvailable
        ? 'ingestion'
        : Definition.getLabel(DEFINITION_CATEGORY__ATS_TYPE, atsTypeId) || ''
  );

  function onClickSendATS(apiName) {
    return async event => {
      setSendingATS(true);
      setSubmitToAtsFailed(false);
      const result = await onClickCallback(apiName);
      if (!result || !!result.errors?.length) {
        setSubmitToAtsFailed(true);
      }
      setSendingATS(false);
    }
  }

  (async () => {
    if (!AtsSubmitButton.busy && !Obj(sovrenRecord).id && isAtsManuallyAvailable && candidate.sovrenDataId) {
      AtsSubmitButton.busy = true;
      setSovrenRecord(
        await readLoopbackRecord({
          collection: COLLECTION__SOVREN_DATA,
          where: { id: candidate.sovrenDataId },
          fields: ['id', 'contactInfo'],
          limit: 1
        })
      );
      AtsSubmitButton.busy = false;
    }
  })();

  return (
    <div className="mt-1">
      <Once
        promise={async () => {
          updateEntity(
            await fetchAtsContext({
              entityId: props.employerId
            })
          );
        }}
      />
      <div className='nowrap'>
        <Button small
          acl={YES__ATS__AVAILABLE}
          onClick={onClickSendATS(apiName)}
          disabled={disabled || isAtsSubmitDisabled}
          className='nowrap mr-1'
          label={
            sendingATS
              ? "SENDING..."
              : `Submit to ATS(${apiName})`
          }
        />
        {isAtsManuallyAvailable && (
          <Button
            className={"hint--top hint--rounded nowrap mr-1"}
            variant='contained'
            color='secondary'
            size='small'
            aria-label={
              !manualSubmissionUrl ? 'Missing manual submission url' : `Take to the ATS URL`
            }
            onClick={async event => {
              const doManualOperation = (prepend) => {
                if (!!Arr(candidate.resumes).length) {
                  fetchCandidateResume({
                    key: 'pdf',
                    download: true,
                    candidate,
                    source: 'AtsSubmitButton__ManualSubmission',
                  }).catch((error) => this.setState({
                    snackbar: error
                  }))
                }
                copyATS({
                  prepend,
                  html: props.emailParams.html,
                  htmlFormat: YES__ATS_TYPE__ASHBY
                });
                window.open(
                  tools.withHttp(manualSubmissionUrl),
                  "_blank"
                );
              }
              if (Obj(sovrenRecord).id) {
                const CANDIDATE_NAME = join([candidate.firstName, candidate.lastName], ' ');
                const PARSED_NAME = join([
                  dig(sovrenRecord, 'contactInfo', 'PersonName', 'GivenName'),
                  dig(sovrenRecord, 'contactInfo', 'PersonName', 'FamilyName'),
                ], ' ');
                if (PARSED_NAME && (PARSED_NAME.toLowerCase() !== CANDIDATE_NAME.toLowerCase())) {
                  Core.showWarning(
                    compile(CANDIDATE_UI.firstName.resumeSubmissionDiffParsedNameErrorMessage)({
                      CANDIDATE_NAME,
                      PARSED_NAME
                    }),
                    () => doManualOperation(CANDIDATE_NAME)
                  )
                }
                else { doManualOperation(); }
              }
              else { doManualOperation(); }
            }}
            disabled={disabled || !manualSubmissionUrl}
          >
            Manual Submit to ATS ({apiName})
          </Button>
        )}
      </div>
      <div className="d-flex flex-column px-05">
        <WarningChipMessage show={isAtsSubmitDisabled && !sendingATS} className='mt-05'>
          Submit to ATS is disabled on development environments for non 10x10 employers.
        </WarningChipMessage>
        <WarningChipMessage show={isAtsManuallyAvailable && !manualSubmissionUrl} className='mt-05'>
          Manual submission URL is missing!
        </WarningChipMessage>
        <ErrorMessage show={isSubmitToAtsFailed} className='mt-05'>
          <small>
            Submit to ATS failed!
          </small><br />
          <small>
            Please review the ATS settings on Employer/Process.
          </small>
        </ErrorMessage>
      </div>
    </div>
  );
}

/* DICTIONARIES =============================== */



/* EXPORTS ==================================== */

export {
  AtsSubmitButton, AtsSubmitButton as default
};

/* ============================================ */